"use client";
//? Library Imports ------------------------------------------------------------>
import { Col, Row, Spin, Modal, Space, Typography } from "antd";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { useState, useMemo } from "react";

//? Modules -------------------------------------------------------------------->
import MediaQueryHook from "@/hooks/useMediaQuery/MediaQueryHook";
import AddToCartModalContent from "./AddToCartModalContent";

//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function AddToCartModal({
  ProductDetail,
  ViewEditProductModal,
  setViewEditProductModal,
  fetchWishlistProducts,
}) {
  //? Hooks ---------------------------------------------------------------------->
  const dispatch = useDispatch();
  const userAgent = MediaQueryHook();
  const { isDesktop } = MediaQueryHook();

  //? Redux States --------------------------------------------------------------->
  const defaultCountryFromCookies = Cookies.get("defaultCountry");
  let defaultgeoLocationCountry = Cookies.get("geoLocation");
  if (!defaultgeoLocationCountry) {
    defaultgeoLocationCountry = defaultCountryFromCookies;
    Cookies.set("geoLocation", defaultCountryFromCookies, {
      expires: 365,
    });
  }

  //? States --------------------------------------------------------------------->
  const SelectedVariantt = useMemo(() => {
    if (
      ProductDetail &&
      ProductDetail.variant_price_inventory &&
      ProductDetail.variants
    ) {
      return ProductDetail?.variants.find(
        (variant) => variant?.variant_detail?.sold_out === false
      );
    } else return ProductDetail?.variants[0];
  }, [ProductDetail]);
  const [SelectedVariant, setSelectedVariant] = useState(SelectedVariantt);

  //? Life Cycles ---------------------------------------------------------------->

  return (
    <Col className="EditProductModal_Container">
      <Modal
        centered
        open={ViewEditProductModal}
        wrapClassName="AddToCartModal"
        style={{ backgroundColor: "white", borderRadius: "10px" }}
        onCancel={() => setViewEditProductModal(false)}
        footer={null} // Remove bottom OK and Cancel buttons
      >
        <AddToCartModalContent
          ISBNPL={ProductDetail?.is_bnpl}
          fetchWishlistProducts={fetchWishlistProducts}
          ProductDetail={ProductDetail}
          userAgent={userAgent}
          SelectedVariant={SelectedVariant}
          setSelectedVariant={setSelectedVariant}
          availableVariants={ProductDetail?.variants}
          collectionName={"Wishlisted Product"}
          setViewEditProductModal={setViewEditProductModal}
        />
      </Modal>
    </Col>
  );
}
